import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useUserContext } from '../user';
import { useWorkspaceContext } from '../workspace';

import ability from './ability';
import { AbilityContext } from './context';

const AbilityContextProvider = ({ children }) => {
  const { userSession } = useUserContext();
  const { workspace: { defaultWorkspace, tasks, allTasks } } = useWorkspaceContext();

  const abilityValue = useMemo(() => (
    ability(defaultWorkspace, userSession, tasks, allTasks)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [defaultWorkspace, userSession, tasks]);

  return (
    <AbilityContext.Provider value={abilityValue}>
      {children}
    </AbilityContext.Provider>
  );
};

AbilityContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AbilityContextProvider;
